import { Text } from '@interco/inter-ui/components/Text'

import * as S from './style'

type Content = {
  title: string
  description: string
}

const ContentText: Content[] = [
  {
    title: 'Limite',
    description: `Informações do cartão, informações sobre o limite do cartão, limite total, limite utilizado, limite disponível, limite por tipo de crédito`,
  },
  {
    title: 'Transações',
    description: `Informações do cartão, identificação de transação, valor da transação, datas, identificação do estabelecimento.`,
  },
  {
    title: 'Faturas',
    description: `Informações do cartão, bandeira do cartão, informações da fatura, encargos e formas de pagamento.`,
  },
]

export const CreditCard = () => (
  <S.Container>
    <Text variant="body-2" style={{ fontSize: 16 }}>
      Estes serão os dados compartilhados:
    </Text>
    {ContentText.map((content) => (
      <S.Content key={content.title}>
        <Text variant="body-1" bold colorWeight={500}>
          {content.title}
        </Text>
        <Text variant="body-2">{content.description}</Text>
      </S.Content>
    ))}
  </S.Container>
)
